import { render } from "./DropdownComp.vue?vue&type=template&id=0df1197b"
import script from "./DropdownComp.vue?vue&type=script&lang=js"
export * from "./DropdownComp.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__